import { default as _91_46_46_46slug_934cI99JhXdwMeta } from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/[...slug].vue?macro=true";
import { default as _91slug_93ZL3ty16d0CMeta } from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/car/[slug].vue?macro=true";
import { default as indexBlME8SVVtBMeta } from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/preview/index.vue?macro=true";
import { default as catalogXYXKSQ23KIMeta } from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/catalog.vue?macro=true";
import { default as customizationqU03A2CpmkMeta } from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/customization.vue?macro=true";
import { default as driver_45detailsD8iTR9rTmCMeta } from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/driver-details.vue?macro=true";
import { default as successnSUReABl2xMeta } from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/success.vue?macro=true";
import { default as thank_45youNSdGgmHeaOMeta } from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/thank-you.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_934cI99JhXdwMeta?.name ?? "slug___en",
    path: _91_46_46_46slug_934cI99JhXdwMeta?.path ?? "/en/:slug(.*)*",
    meta: _91_46_46_46slug_934cI99JhXdwMeta || {},
    alias: _91_46_46_46slug_934cI99JhXdwMeta?.alias || [],
    redirect: _91_46_46_46slug_934cI99JhXdwMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_934cI99JhXdwMeta?.name ?? "slug___es___default",
    path: _91_46_46_46slug_934cI99JhXdwMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_934cI99JhXdwMeta || {},
    alias: _91_46_46_46slug_934cI99JhXdwMeta?.alias || [],
    redirect: _91_46_46_46slug_934cI99JhXdwMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_934cI99JhXdwMeta?.name ?? "slug___es",
    path: _91_46_46_46slug_934cI99JhXdwMeta?.path ?? "/es/:slug(.*)*",
    meta: _91_46_46_46slug_934cI99JhXdwMeta || {},
    alias: _91_46_46_46slug_934cI99JhXdwMeta?.alias || [],
    redirect: _91_46_46_46slug_934cI99JhXdwMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ZL3ty16d0CMeta?.name ?? "car-slug___en",
    path: _91slug_93ZL3ty16d0CMeta?.path ?? "/en/car/:slug()",
    meta: _91slug_93ZL3ty16d0CMeta || {},
    alias: _91slug_93ZL3ty16d0CMeta?.alias || [],
    redirect: _91slug_93ZL3ty16d0CMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/car/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ZL3ty16d0CMeta?.name ?? "car-slug___es___default",
    path: _91slug_93ZL3ty16d0CMeta?.path ?? "/car/:slug()",
    meta: _91slug_93ZL3ty16d0CMeta || {},
    alias: _91slug_93ZL3ty16d0CMeta?.alias || [],
    redirect: _91slug_93ZL3ty16d0CMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/car/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ZL3ty16d0CMeta?.name ?? "car-slug___es",
    path: _91slug_93ZL3ty16d0CMeta?.path ?? "/es/car/:slug()",
    meta: _91slug_93ZL3ty16d0CMeta || {},
    alias: _91slug_93ZL3ty16d0CMeta?.alias || [],
    redirect: _91slug_93ZL3ty16d0CMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/car/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexBlME8SVVtBMeta?.name ?? "preview___en",
    path: indexBlME8SVVtBMeta?.path ?? "/en/preview",
    meta: indexBlME8SVVtBMeta || {},
    alias: indexBlME8SVVtBMeta?.alias || [],
    redirect: indexBlME8SVVtBMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/preview/index.vue").then(m => m.default || m)
  },
  {
    name: indexBlME8SVVtBMeta?.name ?? "preview___es___default",
    path: indexBlME8SVVtBMeta?.path ?? "/preview",
    meta: indexBlME8SVVtBMeta || {},
    alias: indexBlME8SVVtBMeta?.alias || [],
    redirect: indexBlME8SVVtBMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/preview/index.vue").then(m => m.default || m)
  },
  {
    name: indexBlME8SVVtBMeta?.name ?? "preview___es",
    path: indexBlME8SVVtBMeta?.path ?? "/es/preview",
    meta: indexBlME8SVVtBMeta || {},
    alias: indexBlME8SVVtBMeta?.alias || [],
    redirect: indexBlME8SVVtBMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/preview/index.vue").then(m => m.default || m)
  },
  {
    name: catalogXYXKSQ23KIMeta?.name ?? "subscription-catalog___en",
    path: catalogXYXKSQ23KIMeta?.path ?? "/en/subscription/catalog",
    meta: catalogXYXKSQ23KIMeta || {},
    alias: catalogXYXKSQ23KIMeta?.alias || [],
    redirect: catalogXYXKSQ23KIMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/catalog.vue").then(m => m.default || m)
  },
  {
    name: catalogXYXKSQ23KIMeta?.name ?? "subscription-catalog___es___default",
    path: catalogXYXKSQ23KIMeta?.path ?? "/subscription/catalog",
    meta: catalogXYXKSQ23KIMeta || {},
    alias: catalogXYXKSQ23KIMeta?.alias || [],
    redirect: catalogXYXKSQ23KIMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/catalog.vue").then(m => m.default || m)
  },
  {
    name: catalogXYXKSQ23KIMeta?.name ?? "subscription-catalog___es",
    path: catalogXYXKSQ23KIMeta?.path ?? "/es/subscription/catalog",
    meta: catalogXYXKSQ23KIMeta || {},
    alias: catalogXYXKSQ23KIMeta?.alias || [],
    redirect: catalogXYXKSQ23KIMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/catalog.vue").then(m => m.default || m)
  },
  {
    name: customizationqU03A2CpmkMeta?.name ?? "subscription-customization___en",
    path: customizationqU03A2CpmkMeta?.path ?? "/en/subscription/customization",
    meta: customizationqU03A2CpmkMeta || {},
    alias: customizationqU03A2CpmkMeta?.alias || [],
    redirect: customizationqU03A2CpmkMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/customization.vue").then(m => m.default || m)
  },
  {
    name: customizationqU03A2CpmkMeta?.name ?? "subscription-customization___es___default",
    path: customizationqU03A2CpmkMeta?.path ?? "/subscription/customization",
    meta: customizationqU03A2CpmkMeta || {},
    alias: customizationqU03A2CpmkMeta?.alias || [],
    redirect: customizationqU03A2CpmkMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/customization.vue").then(m => m.default || m)
  },
  {
    name: customizationqU03A2CpmkMeta?.name ?? "subscription-customization___es",
    path: customizationqU03A2CpmkMeta?.path ?? "/es/subscription/customization",
    meta: customizationqU03A2CpmkMeta || {},
    alias: customizationqU03A2CpmkMeta?.alias || [],
    redirect: customizationqU03A2CpmkMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/customization.vue").then(m => m.default || m)
  },
  {
    name: driver_45detailsD8iTR9rTmCMeta?.name ?? "subscription-driver-details___en",
    path: driver_45detailsD8iTR9rTmCMeta?.path ?? "/en/subscription/driver-details",
    meta: driver_45detailsD8iTR9rTmCMeta || {},
    alias: driver_45detailsD8iTR9rTmCMeta?.alias || [],
    redirect: driver_45detailsD8iTR9rTmCMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/driver-details.vue").then(m => m.default || m)
  },
  {
    name: driver_45detailsD8iTR9rTmCMeta?.name ?? "subscription-driver-details___es___default",
    path: driver_45detailsD8iTR9rTmCMeta?.path ?? "/subscription/driver-details",
    meta: driver_45detailsD8iTR9rTmCMeta || {},
    alias: driver_45detailsD8iTR9rTmCMeta?.alias || [],
    redirect: driver_45detailsD8iTR9rTmCMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/driver-details.vue").then(m => m.default || m)
  },
  {
    name: driver_45detailsD8iTR9rTmCMeta?.name ?? "subscription-driver-details___es",
    path: driver_45detailsD8iTR9rTmCMeta?.path ?? "/es/subscription/driver-details",
    meta: driver_45detailsD8iTR9rTmCMeta || {},
    alias: driver_45detailsD8iTR9rTmCMeta?.alias || [],
    redirect: driver_45detailsD8iTR9rTmCMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/driver-details.vue").then(m => m.default || m)
  },
  {
    name: successnSUReABl2xMeta?.name ?? "subscription-success___en",
    path: successnSUReABl2xMeta?.path ?? "/en/subscription/success",
    meta: successnSUReABl2xMeta || {},
    alias: successnSUReABl2xMeta?.alias || [],
    redirect: successnSUReABl2xMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/success.vue").then(m => m.default || m)
  },
  {
    name: successnSUReABl2xMeta?.name ?? "subscription-success___es___default",
    path: successnSUReABl2xMeta?.path ?? "/subscription/success",
    meta: successnSUReABl2xMeta || {},
    alias: successnSUReABl2xMeta?.alias || [],
    redirect: successnSUReABl2xMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/success.vue").then(m => m.default || m)
  },
  {
    name: successnSUReABl2xMeta?.name ?? "subscription-success___es",
    path: successnSUReABl2xMeta?.path ?? "/es/subscription/success",
    meta: successnSUReABl2xMeta || {},
    alias: successnSUReABl2xMeta?.alias || [],
    redirect: successnSUReABl2xMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/subscription/success.vue").then(m => m.default || m)
  },
  {
    name: thank_45youNSdGgmHeaOMeta?.name ?? "thank-you___en",
    path: thank_45youNSdGgmHeaOMeta?.path ?? "/en/thank-you",
    meta: thank_45youNSdGgmHeaOMeta || {},
    alias: thank_45youNSdGgmHeaOMeta?.alias || [],
    redirect: thank_45youNSdGgmHeaOMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youNSdGgmHeaOMeta?.name ?? "thank-you___es___default",
    path: thank_45youNSdGgmHeaOMeta?.path ?? "/thank-you",
    meta: thank_45youNSdGgmHeaOMeta || {},
    alias: thank_45youNSdGgmHeaOMeta?.alias || [],
    redirect: thank_45youNSdGgmHeaOMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/thank-you.vue").then(m => m.default || m)
  },
  {
    name: thank_45youNSdGgmHeaOMeta?.name ?? "thank-you___es",
    path: thank_45youNSdGgmHeaOMeta?.path ?? "/es/thank-you",
    meta: thank_45youNSdGgmHeaOMeta || {},
    alias: thank_45youNSdGgmHeaOMeta?.alias || [],
    redirect: thank_45youNSdGgmHeaOMeta?.redirect,
    component: () => import("/Users/jnieto/Projects/web-reborn/nuxt3-reborn/pages/thank-you.vue").then(m => m.default || m)
  }
]